import { FundPage } from './fund_page';

export { FundAssetsTable } from './fund_assets_table';

export default FundPage;
